import { useLocationPath } from "./useLocationPath";

export const useLocationIdFromUrl = () => {
  const path = useLocationPath();
  return path?.params.locationId;
};
